export const billingTypeList = [
  { label: 'CPM', value: 0 },
  { label: 'CPD', value: 1 },
  { label: 'CPA', value: 2 }
]

export const billingTypeMap = {
  0: 'CPM',
  1: 'CPD',
  2: 'CPA'
}
